import React, { useContext } from 'react'
import LeftContent from 'modules/react/signup/LeftContent'
import RightContent from 'modules/react/signup/RightContent'
import SignupContext from 'modules/react/signup/SignupContext'
import FormElementError from 'modules/react/signup/FormElementError'
import CourseDateSelection from 'modules/react/signup/CourseDateSelection'
import NewsletterCheckbox from 'modules/react/signup/NewsletterCheckbox'

export default function Step2Employed () {

  const signupContext = useContext(SignupContext)
  const { submit, goBack, setFormValue, restUrls, setEnterCallback } = signupContext

  React.useEffect(() => {
      setEnterCallback(() => completeSignup)
    }, []
  )

  const completeSignup = () => {
    submit(restUrls.employed.signup)
      .then((response) => {
        if (response.data?.location) {
          window.location.href = response.data.location
        }
      })
  }

  return (
    <>
      <LeftContent>
        <div className="title title--h3">Vælg startdato</div>
        <div className="wysiwyg">Inden vi sender dig videre til den endelige tilmelding på voksenuddannelse.dk, skal du vælge en startdato på dit kursus. Hvis du vælger et kursus i Åbent værksted, skal du vælge halvår under startdatoer. Når du herefter logger ind på voksenuddannel-se.dk skal du vælge den/de endelige kursusdage.
        </div>
        <CourseDateSelection/>
        <div className="title title--h6">Udfyld oplysninger</div>
        <div className="input-group">
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="firstName">
                <input type="text" placeholder="Fornavn" onChange={(e) => setFormValue('firstName', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="lastName">
                <input type="text" placeholder="Efternavn" onChange={(e) => setFormValue('lastName', e.target.value)}/>
              </FormElementError>
            </div>
          </div>
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="phone">
                <input type="text" placeholder="Telefonnr" onChange={(e) => setFormValue('phone', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="email">
                <input type="text" placeholder="Email" onChange={(e) => setFormValue('email', e.target.value.trim())}/>
              </FormElementError>
            </div>
          </div>
        </div>
        <NewsletterCheckbox/>
        <div className="button-section button-section--modal-group">
          <button className="inline-button inline-button--prim inline-button--back" onClick={goBack}>Tilbage</button>
          <button className="button button--next" onClick={completeSignup}>Tilmeld mig</button>
        </div>
      </LeftContent>
      <RightContent>
        <div className="title title--h4">Fuldfør din tilmelding på voksenuddannelse.dk</div>
        <div className="wysiwyg">Uanset om du tilmelder dig selv, en medarbejder eller en kollega, skal din tilmelding ske på voksenuddannelse.dk. Når du har gennemført din tilmelding, bliver din tilmelding registreret i det offentlige system og her hos os. Du modtager en beskræftelsesmail og en indkaldelsesmail fra os med praktiske oplysninger om dit kursus inden kursusstart.
        </div>
        <div className="title title--h6">Hvem tilmelder du?</div>
        <div className="content-columns content-columns--count-3">
          <div className="content-columns__column">
            <div className="title title--h7">Dig selv</div>
            <div className="wysiwyg wysiwyg--fs14">Hvis du vil tilmelde dig selv, skal du have dit NemID eller MitID klar, så du kan logge ind på voksenuddannelse.dk.
            </div>
          </div>
          <span className="content-columns__separator"></span>
          <div className="content-columns__column">
            <div className="title title--h7">En eller flere medarbejdere</div>
            <div className="wysiwyg wysiwyg--fs14">Tilmelder du en eller flere medarbejdere skal du kunne logge ind med din virksomheds NemID eller digitale signatur og have medarbejdernes CPR-nr. og uddannelsesbaggrunde klar.
            </div>
          </div>
          <span className="content-columns__separator"></span>
          <div className="content-columns__column">
            <div className="title title--h7">Selvstændig</div>
            <div className="wysiwyg wysiwyg--fs14">Hvis du er selvstændig og vil tilmeldes, anbefaler vi, at du logger ind med din virksomheds NemID eller digitale signatur.
            </div>
          </div>
        </div>
      </RightContent>
    </>
  )
}